import * as React from "react";
import {
  AutocompleteInput,
  Button,
  Confirm,
  Create,
  ReferenceInput,
  required,
  SelectInput,
  Toolbar,
  useDataProvider,
  useNotify,
} from "react-admin";
import { SourcePbhStatusUpdate, TitlePbhStatusUpdate } from "./PbhStatusUpdateConstant";
import { Card, CircularProgress, Grid } from "@material-ui/core";
import { Form } from "react-final-form";
import { Add } from "@material-ui/icons";
import { useAppDataProvider } from "../../../../dataprovider";
import { useHistory } from "react-router-dom";
import { PbhRequestStatus } from "../../../../Enums/PbhRequestStatus";
import TiptapRichTextInputField from "../../../../../src/Components/TiptapRichTextInput";

const PbhStatusUpdateCreate = props => {
  const newStatusArray: PbhRequestStatus[] = [
    PbhRequestStatus.Open,
    PbhRequestStatus.UnshippedSvc,
    PbhRequestStatus.ServiceableShipped,
  ];
  const notify = useNotify();
  const history = useHistory();
  const dataProvider = useDataProvider();
  const appDataProvider = useAppDataProvider();
  const [statusList, setStatusList] = React.useState([] as any);
  const [loading, setLoading] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [selectedPbhRequestOrder, setSelectedPbhRequestOrder] = React.useState(null as any);
  const [createdData, setCreatedData] = React.useState(null as any);

  const handleDialogClose = () => {
    setOpenDialog(false);
    setCreatedData(null);
  };
  const handleDialogOpen = () => setOpenDialog(true);

  React.useEffect(() => {
    GetStatusList();
  }, []);

  const GetPbhRequestOrderFromId = async id => {
    dataProvider
      .getOne("pbhrequestorders/getbasicdata", {
        id: id,
      })
      .then(response => {
        setSelectedPbhRequestOrder(response.data);
      })
      .catch(error => {});
  };

  const GetStatusList = async () => {
    dataProvider
      .getList("PbhRequestStatusInfos", {
        pagination: { page: 1, perPage: 9999 },
        sort: { field: "id", order: "DESC" },
        filter: { requestStatus__in: newStatusArray },
      })
      .then(response => {
        setStatusList([]);
        if (response?.data?.length > 0) {
          let data = response.data;
          setStatusList(data);
        }
      })
      .catch(error => {
        setStatusList([]);
        console.log(error);
      });
  };

  const refNoChangeEvent = e => {
    GetPbhRequestOrderFromId(e);
  };

  const handleSubmit = async e => {
    let data = e;
    data.refNo = selectedPbhRequestOrder?.refNo;
    setCreatedData(e);
    handleDialogOpen();
  };

  const OnClickAccept = async e => {
    setLoading(true);
    appDataProvider
      .createPbhStatusUpdate(createdData)
      .then(response => {
        notify(`Status updated successfully`, "success", false, true);
        history.push("/pbhstatusupdates");
      })
      .catch(error => {
        notify(error, { type: "warning" });
      })
      .finally(() => {
        setLoading(false);
        handleDialogClose();
      });
  };

  const onFailure = error => notify(error?.response?.data, { type: "warning" });

  return (
    <Create {...props} title={TitlePbhStatusUpdate.create} onFailure={onFailure} resource={SourcePbhStatusUpdate}>
      <Grid>
        <Form
          onSubmit={handleSubmit}
          render={({ handleSubmit, form }) => (
            <Card>
              <form>
                <Card>
                  <Grid container spacing={0} style={{ padding: 25 }}>
                    <ReferenceInput
                      label="Ref No"
                      source="requestId"
                      resource="refNo"
                      reference={"pbhrequestorders/getpbhrequestlist"}
                      filterToQuery={optionText => ({ refNo__contains: optionText })}
                      enableGetChoices={({ q }) => q && q.length >= 4}
                      fullWidth
                      variant="outlined"
                      onChange={refNoChangeEvent}
                      validate={required()}
                    >
                      <AutocompleteInput
                        source="requestId"
                        optionText="refNo"
                        optionValue="id"
                        variant="outlined"
                        resettable
                        fullWidth
                      />
                    </ReferenceInput>
                    <SelectInput
                      label="Current Status"
                      source="previousStatus"
                      choices={statusList}
                      optionText="displayName"
                      optionValue="requestStatus"
                      defaultValue={selectedPbhRequestOrder?.requestStatus}
                      initialValue={selectedPbhRequestOrder?.requestStatus}
                      fullWidth
                      variant="outlined"
                      validate={required()}
                      disabled
                    />
                    <SelectInput
                      label="New Status"
                      source="newStatus"
                      choices={statusList}
                      optionText="displayName"
                      optionValue="requestStatus"
                      fullWidth
                      variant="outlined"
                      validate={required()}
                    />
                    <TiptapRichTextInputField source="remark" validate={[required()]} />
                  </Grid>
                </Card>
                <Toolbar {...props} placeholder="">
                  <Confirm
                    isOpen={openDialog}
                    loading={loading}
                    title={`Update Status`}
                    content={"Are you sure you want to change the status of " + selectedPbhRequestOrder?.refNo + " ?"}
                    onConfirm={OnClickAccept}
                    onClose={handleDialogClose}
                  />
                  <Button
                    label={loading ? "Updating Status!" : "Update Status"}
                    disabled={loading}
                    size="medium"
                    variant="contained"
                    style={{ margin: "8px" }}
                    onClick={() => handleSubmit()}
                  >
                    {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                  </Button>
                </Toolbar>
              </form>
            </Card>
          )}
        />
      </Grid>
    </Create>
  );
};

export default PbhStatusUpdateCreate;
